import { render, staticRenderFns } from "./related-cards-table.vue?vue&type=template&id=3b8b666c&"
import script from "./related-cards-table.vue?vue&type=script&lang=ts&"
export * from "./related-cards-table.vue?vue&type=script&lang=ts&"
import style0 from "./related-cards-table.vue?vue&type=style&index=0&id=3b8b666c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports